(() => {
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root)) return;
    const viewport = root.querySelector('.cf-carousel-viewport');
    const track = root.querySelector('.cf-carousel-track');
    const originals = [...track.children];
    if (originals.length < 2) return;
    const abort = new AbortController();
    const options = { signal: abort.signal };
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let width = 0, position = 0, frame = 0, lastTime = 0;
    let paused = reduced.matches, hovered = false, focused = false, visible = false;
    let dragging = false, startX = 0, startScroll = 0, moved = false, resumeAt = 0;
    const clone = card => {
      const copy = card.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('tabindex', '-1');
      copy.dataset.clone = 'true';
      copy.querySelectorAll('img').forEach(img => img.alt = '');
      return copy;
    };
    track.prepend(...originals.map(clone));
    track.append(...originals.map(clone));
    const toggle = root.querySelector('[data-carousel-pause]');
    const setToggle = () => {
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);

    };
    const measure = () => {
      const oldWidth = width;
      width = originals[0].offsetLeft - track.firstElementChild.offsetLeft;
      position = width + (oldWidth ? ((viewport.scrollLeft % oldWidth) / oldWidth) * width : 0);
      viewport.scrollLeft = position;
    };
    const normalize = () => {
      if (!width) return;
      if (viewport.scrollLeft < width * .5) viewport.scrollLeft += width;
      else if (viewport.scrollLeft >= width * 2.5) viewport.scrollLeft -= width;
      position = viewport.scrollLeft;
    };
    const tick = time => {
      if (!root.isConnected) return;
      const delta = lastTime ? Math.min(time - lastTime, 50) : 0;
      lastTime = time;
      if (visible && !paused && !hovered && !focused && !dragging && !document.hidden && time > resumeAt && width) {
        position += delta * .025;
        if (position >= width * 2.5) position -= width;
        viewport.scrollLeft = position;
      }
      frame = requestAnimationFrame(tick);
    };
    viewport.addEventListener('scroll', () => {
      if (dragging || hovered || focused || paused || performance.now() < resumeAt) {
        position = viewport.scrollLeft;
        if (!dragging) normalize();
      }
    }, options);
    viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hovered = true; }, options);
    viewport.addEventListener('pointerleave', () => { hovered = false; position = viewport.scrollLeft; }, options);
    viewport.addEventListener('focusin', event => { focused = event.target.matches(':focus-visible'); }, options);
    viewport.addEventListener('focusout', event => { focused = viewport.contains(event.relatedTarget); position = viewport.scrollLeft; }, options);
    toggle.addEventListener('click', () => { paused = !paused; focused = false; position = viewport.scrollLeft; resumeAt = 0; setToggle(); }, options);
    const step = direction => {
      resumeAt = performance.now() + 2500;
      viewport.scrollLeft += direction * (originals[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap));
      normalize();
    };
    root.querySelector('[data-carousel-prev]').addEventListener('click', () => step(-1), options);
    root.querySelector('[data-carousel-next]').addEventListener('click', () => step(1), options);
    viewport.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); step(event.key === 'ArrowLeft' ? -1 : 1); }
    }, options);
    viewport.addEventListener('pointerdown', event => {
      dragging = true; moved = false; startX = event.clientX; startScroll = viewport.scrollLeft;
    }, options);
    viewport.addEventListener('pointermove', event => {
      if (!dragging || event.pointerType !== 'mouse') return;
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 5) { moved = true; viewport.scrollLeft = startScroll - distance; }
    }, options);
    window.addEventListener('pointerup', () => { if (!dragging) return; dragging = false; resumeAt = performance.now() + 4000; normalize(); }, options);
    viewport.addEventListener('pointercancel', () => { dragging = false; resumeAt = performance.now() + 4000; normalize(); }, options);
    viewport.addEventListener('touchmove', () => { resumeAt = performance.now() + 4000; }, { ...options, passive: true });
    viewport.addEventListener('wheel', () => { resumeAt = performance.now() + 3000; position = viewport.scrollLeft; }, { ...options, passive: true });
    viewport.addEventListener('dragstart', event => event.preventDefault(), options);
    viewport.addEventListener('click', event => { if (moved) { event.preventDefault(); moved = false; } }, options);
    reduced.addEventListener('change', () => { paused = reduced.matches; setToggle(); }, options);
    const resize = new ResizeObserver(measure);
    resize.observe(viewport);
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
    observer.observe(root);
    root.querySelector('.cf-carousel-controls').hidden = false;
    measure(); setToggle(); frame = requestAnimationFrame(tick);
    instances.set(root, () => { abort.abort(); resize.disconnect(); observer.disconnect(); cancelAnimationFrame(frame); });
  }
  const scan = () => document.querySelectorAll('[data-cf-carousel]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-cf-carousel]').forEach(root => instances.get(root)?.());
  });
})();
